import { render, staticRenderFns } from "./AtServiceDocumentsManager.vue?vue&type=template&id=b131bd9a&scoped=true"
import script from "./AtServiceDocumentsManager.vue?vue&type=script&lang=js"
export * from "./AtServiceDocumentsManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b131bd9a",
  null
  
)

export default component.exports